import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../../redux/modals/action';
import Modal from '../../../layout/modal/Modal';
import LeadsForm from '../../../sendEmail/forms/LeadsForm';
import styles from './AddLeadsModal.module.scss';

const Addleadsmodal = ({
	// parent props
	openModal,
	handleLeads,
	leadById,
	editKey,
	// redux
	closeModal,
}) => {
	useEffect(() => {
		console.log('wdfwdsfwf', editKey);
	}, [editKey]);
	return (
		<div className={styles.addLeadsModal}>
			<Modal
				show={openModal}
				button={handleLeads}
				close={() => closeModal('addLeads')}
				title={editKey ? 'Edit Leads' : 'Add Leads'}
				wrapperWidth='90%'
				wrapperMax={830}
			>
				<LeadsForm
					show={openModal}
					source='portal'
					leadById={leadById}
					editKey={editKey}
					// isAdd={isAdd}
				/>
			</Modal>
		</div>
	);
};

export default connect(null, { closeModal })(Addleadsmodal);
